module.exports = __webpack_public_path__ + "static/gufs_right_section@2x-8329b1add150df13e3b954d4e3f8ad20.png";